import { useMelwaysInfo, useMelwaysLink } from '@seek/melways-react';
import { HOMEPAGE_LANGUAGE_OVERRIDE_PATH } from '@seek/melways-sites';

import { isAbsoluteUrl } from '../utils/isAbsoluteUrl';
import { isLocalisedPath } from '../utils/isLocalisedPath';

const HOMEPAGE_PATHS = ['/', '/en', '/id', '/th'];

const useCustomLink = (href: string) => {
  const { language } = useMelwaysInfo();

  const isHomePath = HOMEPAGE_PATHS.includes(href);
  const localize = useMelwaysLink();
  if (
    (!isAbsoluteUrl(href) && !isLocalisedPath({ path: href, language })) ||
    isHomePath
  ) {
    const targetPath = isHomePath ? HOMEPAGE_LANGUAGE_OVERRIDE_PATH : href;
    return localize({
      path: targetPath,
    });
  }
  return href;
};

export default useCustomLink;
